import util from '@bmp-vue/core/api/util'

const controller = 'GroupRoles'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByGroup: function (groupId) {
    return util.Axios.Get(controller + '/GetAllByGroup', groupId)
  }
})
